export const POINTS_WIN = 3;
export const POINTS_NEAR_LOSS = 1;
export const POINTS_LOSS = 0;
export const NEAR_LOSS_MARGIN = 3;

export function pointsEarnedInRace (race, squadId) {
  if (race.winningSquadId === squadId) return POINTS_WIN;
  const points = race.goalsBySquadId[squadId] || 0;
  if (points >= race.league.pointsToWin - NEAR_LOSS_MARGIN) return POINTS_NEAR_LOSS;
  return POINTS_LOSS;
}
